export interface SelectionItem {
  id: number | string;
  name: string;
  isActive?: boolean;
}
